import { defineMessages } from 'react-intl';

export default defineMessages({

    buildingCodeClass: {
        "id": "quoteandbind.ho.views.construction.Building Code Class",
        "defaultMessage": "Building Code Class"
    },
    buildingCode: {
        "id": "quoteandbind.ho.views.construction.Building Code",
        "defaultMessage": "Building Code"
    },
    addedLivingSpConDate: {
        "id": "quoteandbind.ho.views.construction.Added Living Space Construction Date",
        "defaultMessage" : "Added Living Space Construction Date"
    },
    orgConstructionDate: {
        "id": "quoteandbind.ho.views.construction.Original Construction Date",
        "defaultMessage" : "Original Construction Date"
    },
    // DE15593
    yearMustmatch: {
        "id": "quoteandbind.ho.views.construction.The Original Construction Date must be within the Year Built",
        "defaultMessage" : "The Original Construction Date must be within the Year Built."
    },
    cannotBeFutureDate: {
        "id": "quoteandbind.ho.views.construction.Date cannot be in the future.",
        "defaultMessage" : "Date cannot be in the future."
    },
    dateAlert: {
        "id" : "quoteandbind.ho.views.construction.Alert",
        "defaultMessage": "Alert"
    },
    dateMustmatch: {
        id: "quoteandbind.ho.views.construction.Please enter a valid date (MM/DD/YYYY).",
        defaultMessage : "Please enter a valid date (MM/DD/YYYY)."
    }

})